import { MapPin, Phone, Mail, Globe, Factory } from "lucide-react";
import { MaskLines, Reveal } from "../components/site/Reveal";
import { EnquiryForm } from "../components/site/EnquiryForm";
import { COMPANY } from "../data/products";
import { useTitle } from "../lib/useTitle";

const ROWS = [
  { icon: MapPin, label: "Head office", value: COMPANY.address },
  { icon: Phone, label: "Phone", value: COMPANY.phone, href: COMPANY.phoneHref },
  { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}` },
  { icon: Globe, label: "Website", value: COMPANY.website },
  { icon: Factory, label: "Manufacturing", value: "Noida, Uttar Pradesh · AURIC, Aurangabad, Maharashtra" },
];

export default function Contact() {
  useTitle("Contact & Request a Quote | Gait Naurish Ltd.");
  return (
    <main data-testid="contact-page" className="relative grain pt-40 md:pt-48">
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 pb-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="eyebrow text-[var(--moss)]">Contact · Quote · Partnership</p>
          <MaskLines
            testId="contact-heading"
            className="font-display text-5xl sm:text-6xl lg:text-7xl font-light leading-[0.98] tracking-tight text-[var(--forest)] mt-6"
            lines={["Let's make", <em key="f" className="text-[var(--amber)]">your feed</em>, "irresistible."]}
          />
          <div className="mt-12 space-y-6">
            {ROWS.map(({ icon: Icon, label, value, href }, i) => (
              <Reveal key={label} delay={i * 0.06} className="flex gap-4 border-b border-[var(--line)] pb-5">
                <Icon size={20} className="text-[var(--amber)] shrink-0 mt-1" />
                <div>
                  <p className="font-mono text-[11px] uppercase tracking-widest text-[var(--muted)]">{label}</p>
                  {href ? (
                    <a href={href} data-testid={`contact-${label.toLowerCase()}`} className="font-display text-xl text-[var(--forest)] link-underline">{value}</a>
                  ) : (
                    <p data-testid={`contact-${label.toLowerCase().replace(" ", "-")}`} className="font-display text-xl text-[var(--forest)]">{value}</p>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7 rounded-[28px] bg-[var(--paper)] border border-[var(--line)] p-7 md:p-12 self-start">
          <EnquiryForm defaultProduct="PALATIVA" />
        </div>
      </section>
    </main>
  );
}
